import { Card, CardContent, Grid, Paper, Slide, Stack, Switch, Typography } from "@mui/material";
import React, { useState } from "react";
import { DatosFactura } from "./DatosFactura";

export const GroupRequireInvoice = (props) => {
    // Para el switch 
    const [requireInvoice, setRequireInvoice] = useState(false);
    const switchHandler = (event) => {
        
        setRequireInvoice(event.target.checked);

        const switchData = { 
            target:{
                name:event.target.name, 
                value:event.target.checked 
            }
        };
        onTrigger(switchData);

    };

    // En cualquier cambio de cualquier control
    const onTrigger = (event) => {
        props.parentCallback(event);
    }

    return (
        <>
            <Grid container spacing={2} sx={{ pt: 2 }} >
                <Grid item xs={12}>
                <Paper elevation={2} >
                    <Card variant="outlined" >
                    <CardContent>
                        {/* Requiere factura */}
                        <Grid item xs={12} sx={{ pt: 1 }}>
                            <Stack direction="row" spacing={1} alignItems="center">
                                <Switch 
                                    checked={requireInvoice} 
                                    id={'requiereFactura'}
                                    inputProps={{ 'aria-label': 'ant design' }} 
                                    name={'requiereFactura'}
                                    onChange={switchHandler}
                                />
                                <Typography>{ props.mainLabel }</Typography>
                            </Stack>
                        </Grid>

                        <Slide direction="up" timeout={600} in={requireInvoice} >
                            
                            <Grid item xs={12} sx={ requireInvoice ? { pt: 2, display:'flex' } : { pt: 2, display:'none' } }>
                                <DatosFactura parentCallback={onTrigger} />
                            </Grid>
                            
                        </Slide>

                    </CardContent>
                    </Card>
                </Paper>
                </Grid>
            </Grid>   
        </>
    );
};
